import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { downloadFile, getFileTypeFromFilename } from "../utils/file";
import useBoolean from "../hooks/useBoolean";
import { DocAPI } from "../api";
import useMessage, { AntDMessage } from "../hooks/useMessage";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { Xmark } from "iconoir-react";

type FilePreviewProp = {
  filename: string;
  children: (props: {
    previewRemoteFile: (urn: string) => Promise<void>;
    previewLocalFile: (file: File) => void;
    loading: boolean;
  }) => React.ReactNode;
};
const FilePreview: React.FC<FilePreviewProp> = ({ filename, children }) => {
  const [link, setLink] = useState<string | null>(null);
  const [loading, { set: setLoading }] = useBoolean();
  const message = useMessage();
  const fileType = getFileTypeFromFilename(filename);
  const previewRemoteFile = async (urn: string) => {
    setLoading(true);
    DocAPI.getLink(urn)
      .then((data) => {
        if (fileType === "unknown") {
          downloadDocVaultFile(data, filename, message);
        } else {
          setLink(data);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };
  const previewLocalFile = (file: File) => {
    const objectUrl = URL.createObjectURL(file);
    if (fileType === "unknown") {
      downloadDocVaultFile(objectUrl, filename, message);
    } else {
      setLink(objectUrl);
    }
  };
  return (
    <>
      {children({ previewRemoteFile, previewLocalFile, loading })}
      <Dialog
        open={fileType === "pdf" && Boolean(link)}
        fullScreen
        maxWidth={false}
        disableEscapeKeyDown={false}
        hideBackdrop={false}
        PaperProps={{
          sx: {
            width: "90vw",
            height: "90vh",
            m: 0,
            p: 0,
          },
        }}
        onClose={() => setLink(null)}
      >
        <DialogContent sx={{ position: "relative", padding: 0 }}>
          <IconButton
            onClick={() => setLink(null)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <Xmark />
          </IconButton>
          {link && (
            <embed
              src={link}
              width="100%"
              height="100%"
              type="application/pdf"
              style={{ border: "none", display: "block" }}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={fileType === "image" && Boolean(link)}
        onClose={() => setLink(null)}
        maxWidth={false}
        PaperProps={{
          sx: {
            p: 0,
            m: 0,
            display: "inline-block",
          },
        }}
      >
        <DialogContent sx={{ position: "relative" }}>
          <IconButton
            onClick={() => setLink(null)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <Xmark />
          </IconButton>
          {link && (
            <img src={link!} style={{ maxWidth: "100%", maxHeight: "80vh" }} />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

function downloadDocVaultFile(
  link: string,
  filename: string,
  message: AntDMessage
) {
  message.info("The file format is not supported for preview.");
  try {
    downloadFile(link, filename);
  } catch (error) {
    message.error("File Download Failed");
    console.error(error);
  }
}

export default FilePreview;
